import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon } from 'lucide-react';
export function ExperienceSection() {
  return <section id="experience" className="py-20 sm:py-28 px-4" aria-labelledby="experience-heading" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-93">
          <h2 id="experience-heading" className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-94">
            Experience
          </h2>
          <div className="w-20 h-1 bg-emerald-500 mx-auto rounded-full" aria-hidden="true" data-id="element-95" />
        </motion.div>

        {/* Timeline */}
        <div className="relative" data-id="element-96">
          {/* Timeline line */}
          <div className="absolute left-0 sm:left-1/2 top-0 bottom-0 w-px bg-slate-700 transform sm:-translate-x-1/2" aria-hidden="true" data-id="element-97" />

          {/* Experience 0 — Freelance */}
          <motion.article initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="relative pl-8 sm:pl-8 sm:ml-auto sm:w-1/2 mb-12" data-id="element-98">
            <div className="absolute left-0 top-0 w-3 h-3 bg-indigo-500 rounded-full transform -translate-x-1.5 ring-4 ring-slate-950" aria-hidden="true" data-id="element-99" />
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-indigo-600 transition-colors" data-id="element-100">
              <div className="flex items-center gap-2 text-indigo-400 text-sm font-medium mb-2" data-id="element-101">
                <BriefcaseIcon className="w-4 h-4" aria-hidden="true" data-id="element-102" />
                <time dateTime="2024-04" data-id="element-103">Apr 2024 – Present</time>
              </div>

              <h3 className="text-xl font-bold text-white mb-1" data-id="element-104">
                Freelance Website Developer
              </h3>
              <p className="text-slate-400 mb-1" data-id="element-105">Self-employed</p>
              <p className="text-slate-500 text-xs mb-4" data-id="element-106">Australia & Remote</p>

              <p className="text-slate-400 text-sm italic mb-4" data-id="element-107">
                Building modern, performance-focused websites for small
                businesses and individual clients.
              </p>

              <ul className="space-y-2 text-slate-300 text-sm" data-id="element-108">
                <li className="flex items-start gap-2" data-id="element-109">
                  <span className="text-indigo-400 mt-1.5" data-id="element-110">▹</span>
                  Designed and developed responsive websites based on client
                  requirements, branding, and business goals
                </li>
                <li className="flex items-start gap-2" data-id="element-111">
                  <span className="text-indigo-400 mt-1.5" data-id="element-112">▹</span>
                  Built landing pages, booking forms, and admin dashboards with
                  clean UI and smooth user experience
                </li>
                <li className="flex items-start gap-2" data-id="element-113">
                  <span className="text-indigo-400 mt-1.5" data-id="element-114">▹</span>
                  Integrated third-party services such as Google Calendar,
                  authentication, and cloud storage
                </li>
                <li className="flex items-start gap-2" data-id="element-115">
                  <span className="text-indigo-400 mt-1.5" data-id="element-116">▹</span>
                  Worked directly with clients to gather requirements, provide
                  technical guidance, and deliver solutions end-to-end
                </li>
              </ul>

              <div className="flex flex-wrap gap-1.5 mt-4" data-id="element-117">
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-118">
                  React
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-119">
                  Next.js
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-120">
                  Tailwind CSS
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-121">
                  TypeScript
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-122">
                  Supabase
                </span>
              </div>
            </div>
          </motion.article>

          {/* Experience 1 — MindX */}
          <motion.article initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="relative pl-8 sm:pl-0 sm:pr-8 sm:w-1/2 mb-12" data-id="element-123">
            <div className="absolute left-0 sm:left-auto sm:right-0 top-0 w-3 h-3 bg-emerald-500 rounded-full transform -translate-x-1.5 sm:translate-x-1.5 ring-4 ring-slate-950" aria-hidden="true" data-id="element-124" />
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-600 transition-colors" data-id="element-125">
              <div className="flex items-center gap-2 text-emerald-400 text-sm font-medium mb-2" data-id="element-126">
                <BriefcaseIcon className="w-4 h-4" aria-hidden="true" data-id="element-127" />
                <time dateTime="2023-11" data-id="element-128">Nov 2023 – Apr 2024</time>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-129">
                Teaching Assistant &amp; Tutor
              </h3>
              <p className="text-slate-400 mb-1" data-id="element-130">MindX Technology School</p>
              <p className="text-slate-500 text-xs mb-4" data-id="element-131">Vietnam</p>
              <p className="text-slate-400 text-sm italic mb-4" data-id="element-132">
                Pioneers technology education for all, from kids to career
                changers.
              </p>
              <ul className="space-y-2 text-slate-300 text-sm" data-id="element-133">
                <li className="flex items-start gap-2" data-id="element-134">
                  <span className="text-emerald-400 mt-1.5" aria-hidden="true" data-id="element-135">
                    ▹
                  </span>
                  Assisted lead instructors in preparing lesson plans, course
                  materials, and hands-on activities
                </li>
                <li className="flex items-start gap-2" data-id="element-136">
                  <span className="text-emerald-400 mt-1.5" aria-hidden="true" data-id="element-137">
                    ▹
                  </span>
                  Provided guidance and support to students, helping them
                  understand key concepts and homework
                </li>
                <li className="flex items-start gap-2" data-id="element-138">
                  <span className="text-emerald-400 mt-1.5" aria-hidden="true" data-id="element-139">
                    ▹
                  </span>
                  Conducted trial lessons to help parents and students
                  understand the teaching method and knowledge students will
                  learn
                </li>
                <li className="flex items-start gap-2" data-id="element-140">
                  <span className="text-emerald-400 mt-1.5" aria-hidden="true" data-id="element-141">
                    ▹
                  </span>
                  Led instructional sessions, taking on primary teaching
                  responsibilities for select course modules
                </li>
                <li className="flex items-start gap-2" data-id="element-142">
                  <span className="text-emerald-400 mt-1.5" aria-hidden="true" data-id="element-143">
                    ▹
                  </span>
                  Taught and supported courses in Web Development (Basic &amp;
                  Advanced), Game Development, and Python Fundamentals
                </li>
              </ul>
            </div>
          </motion.article>

          {/* Experience 2 — Aureole IT */}
          <motion.article initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative pl-8 sm:pl-8 sm:ml-auto sm:w-1/2 mb-12" data-id="element-144">
            <div className="absolute left-0 top-0 w-3 h-3 bg-amber-500 rounded-full transform -translate-x-1.5 ring-4 ring-slate-950" aria-hidden="true" data-id="element-145" />
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-600 transition-colors" data-id="element-146">
              <div className="flex items-center gap-2 text-amber-400 text-sm font-medium mb-2" data-id="element-147">
                <BriefcaseIcon className="w-4 h-4" aria-hidden="true" data-id="element-148" />
                <time dateTime="2022-10" data-id="element-149">Oct – Dec 2022</time>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-150">
                Software Engineer Intern
              </h3>
              <p className="text-slate-400 mb-1" data-id="element-151">Aureole IT Vietnam</p>
              <p className="text-slate-500 text-xs mb-4" data-id="element-152">Vietnam</p>
              <p className="text-slate-400 text-sm italic mb-4" data-id="element-153">
                Specializes in developing tailored software solutions for major
                Japanese companies.
              </p>
              <ul className="space-y-2 text-slate-300 text-sm" data-id="element-154">
                <li className="flex items-start gap-2" data-id="element-155">
                  <span className="text-amber-400 mt-1.5" aria-hidden="true" data-id="element-156">
                    ▹
                  </span>
                  Built a dynamic, interactive lottery website for the company's
                  year-end event, ensuring a user-friendly experience and
                  high-performance standards
                </li>
                <li className="flex items-start gap-2" data-id="element-157">
                  <span className="text-amber-400 mt-1.5" aria-hidden="true" data-id="element-158">
                    ▹
                  </span>
                  Collaborated with seven fellow interns using AGILE methodology
                  to design and develop a sample product under mentor guidance
                </li>
                <li className="flex items-start gap-2" data-id="element-159">
                  <span className="text-amber-400 mt-1.5" aria-hidden="true" data-id="element-160">
                    ▹
                  </span>
                  Participated in weekly meetings to discuss project strategies,
                  troubleshoot issues, and identify areas for improvement
                </li>
                <li className="flex items-start gap-2" data-id="element-161">
                  <span className="text-amber-400 mt-1.5" aria-hidden="true" data-id="element-162">
                    ▹
                  </span>
                  Ensured seamless performance of web applications across
                  multiple browsers, optimizing for functionality and
                  responsiveness
                </li>
              </ul>
              <div className="flex flex-wrap gap-1.5 mt-4" data-id="element-163">
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-164">
                  Next.js
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-165">
                  Tailwind CSS
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-166">
                  Firebase
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-167">
                  Redux
                </span>
              </div>
            </div>
          </motion.article>

          {/* Experience 3 — CareerLink */}
          <motion.article initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="relative pl-8 sm:pl-0 sm:pr-8 sm:w-1/2 mb-12" data-id="element-168">
            <div className="absolute left-0 sm:left-auto sm:right-0 top-0 w-3 h-3 bg-cyan-500 rounded-full transform -translate-x-1.5 sm:translate-x-1.5 ring-4 ring-slate-950" aria-hidden="true" data-id="element-169" />
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-600 transition-colors" data-id="element-170">
              <div className="flex items-center gap-2 text-cyan-400 text-sm font-medium mb-2" data-id="element-171">
                <BriefcaseIcon className="w-4 h-4" aria-hidden="true" data-id="element-172" />
                <time dateTime="2022-07" data-id="element-173">Jul – Oct 2022</time>
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-174">
                ReactJS Developer Intern
              </h3>
              <p className="text-slate-400 mb-1" data-id="element-175">CareerLink</p>
              <p className="text-slate-500 text-xs mb-4" data-id="element-176">Vietnam</p>
              <p className="text-slate-400 text-sm italic mb-4" data-id="element-177">
                A job-seeking platform with a built-in CV builder editable on
                mobile browsers, attracting 1 million active users monthly.
              </p>
              <ul className="space-y-2 text-slate-300 text-sm" data-id="element-178">
                <li className="flex items-start gap-2" data-id="element-179">
                  <span className="text-cyan-400 mt-1.5" aria-hidden="true" data-id="element-180">
                    ▹
                  </span>
                  Optimized website performance and maintainability through
                  effective code refactoring
                </li>
                <li className="flex items-start gap-2" data-id="element-181">
                  <span className="text-cyan-400 mt-1.5" aria-hidden="true" data-id="element-182">
                    ▹
                  </span>
                  Designed and implemented user-friendly resume templates in
                  collaboration with the design team
                </li>
                <li className="flex items-start gap-2" data-id="element-183">
                  <span className="text-cyan-400 mt-1.5" aria-hidden="true" data-id="element-184">
                    ▹
                  </span>
                  Enhanced and tested web applications to improve user
                  experience and resolve technical issues
                </li>
              </ul>
              <div className="flex flex-wrap gap-1.5 mt-4" data-id="element-185">
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-186">
                  ReactJS
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-187">
                  Material-UI
                </span>
                <span className="px-2 py-0.5 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-400" data-id="element-188">
                  JSS
                </span>
              </div>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}